/**
 * The app preview's mode lives in the URL alone (S3 of
 * `.scratch/app-data-settings/SPEC.md`): `?preview=app-user` shows the app the
 * way the people using it get it, `?preview=me` with the signed-in user's own
 * access. Whoever leaves the URL leaves the mode — nothing to tidy up.
 */
export const PREVIEW_AS_APP_USER = 'app-user'
export const PREVIEW_AS_ME = 'me'

/**
 * The app a route previews as its users see it, or null.
 */
export function previewedAppIdFor(route) {
  if (route?.query?.preview !== PREVIEW_AS_APP_USER) {
    return null
  }
  const appId = parseInt(route.params?.appId, 10)
  return Number.isInteger(appId) ? appId : null
}
